import type { GridDataSource, GridGetRowsParams, GridGetRowsResponse } from '@mui/x-data-grid';
import type { AppDispatch } from '../../../store';
import { getRequests } from '../../../slices/apis/requestApi';
import type { GetRequestsResponseData, RequestFilters } from '../../../slices/apis/apis.types';

export function createRequestsDataSource(dispatch: AppDispatch, requestFilters: RequestFilters = {}): GridDataSource {
	return {
		getRows: async (params: GridGetRowsParams): Promise<GridGetRowsResponse> => {
			const query = dispatch(
				getRequests.initiate({
					paginationModel: params.paginationModel,
					sortModel: params.sortModel || [],
					filterModel: params.filterModel || {},
					requestFilters,
				}),
			);

			try {
				const result = await query.unwrap();

				return {
					rows:
						result?.data?.map((request: GetRequestsResponseData) => ({
							id: request.id,
							candidateName: request.candidateName,
							phone: request.candidate.phone,
							user: `${request.user.firstname} ${request.user.lastname}`,
							employer: request.candidate.employer,
							testCentre: request.supplier.name,
							assessmentDate: request.assessmentDates[0] ? new Date(request.assessmentDates[0]) : null,
							paymentStatus: request.paymentStatus,
							status: request.status,
							isArchived: request.isArchived,
							actions: '',
							request,
						})) ?? [],
					rowCount: result?.total ?? 0,
				};
			} catch (error) {
				console.error('Failed to load requests:', error);
				throw error;
			} finally {
				query.unsubscribe();
			}
		},
	};
}
